import type { Block, ParagraphData } from "../../../../models/ManualAuthoring";
import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import StructuredInlineTextEditor from "../editor/StructuredInlineTextEditor";
import "./paragraphIndented.css";

export default function ParagraphIndentedEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-paragraph-indented-edit">
      <StructuredInlineTextEditor
        textParts={data.textParts}
        onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
        onDone={onDone}
      />
    </div>
  );
}
